import React from 'react'
import { BundlePlanCustomPricing } from 'Features/pricing/components/BundlePlanBox/BundlePlanBox.styled'
import {
  BundlePlanBoxButtonAndPrice,
  BundlePlanBoxPrice,
  BundlePlanBoxPriceRow,
  PlanBoxAmount,
  PlanBoxCurrency,
  PlanBoxOriginalPrice,
  PlanBoxPeriod,
  BundlePlanBoxBilledAnnually,
} from './MobileCheckOut.styled'
import { Button } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'

type MobileCheckOutProps = {
  amountWithCurrency: string
  priceBeforeDiscount: string
  isLetsTalk: boolean
  isLoading: boolean
  handleClick: () => void
}

const ButtonCSS = {
  minWidth: '134px',
  maxWidth: '134px',
  height: '42px',
  maxHeight: '42px',
  padding: '0',
}

export const MobileCheckOut = ({
  amountWithCurrency,
  priceBeforeDiscount,
  isLetsTalk,
  isLoading,
  handleClick,
}: MobileCheckOutProps) => {
  const { t } = useTranslation('pricing')

  return (
    <BundlePlanBoxButtonAndPrice>
      {!isLetsTalk ? (
        <BundlePlanBoxPrice>
          <BundlePlanBoxPriceRow>
            <PlanBoxCurrency>{amountWithCurrency}</PlanBoxCurrency>
            <PlanBoxAmount>{}</PlanBoxAmount>

            <PlanBoxPeriod>/m</PlanBoxPeriod>
            <PlanBoxOriginalPrice>{priceBeforeDiscount}</PlanBoxOriginalPrice>
          </BundlePlanBoxPriceRow>
          <BundlePlanBoxBilledAnnually>
            {t('bundles.billed_annually_or_monthly')}
          </BundlePlanBoxBilledAnnually>
        </BundlePlanBoxPrice>
      ) : (
        <BundlePlanCustomPricing> {t('bundles.custom_pricing')}</BundlePlanCustomPricing>
      )}

      <Button
        loading={isLoading}
        disabled={isLoading}
        onClick={handleClick}
        css={ButtonCSS}
        text={isLetsTalk ? t('lets_talk') : t('bundles.start_free_trial')}
      />
    </BundlePlanBoxButtonAndPrice>
  )
}
